import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

// 🎯 بوابة واحدة فوق كل الراوتات بدل ما تتحط جوه ProtectedRoute (مستخدم في
// حوالي 130 مكان) - لاحظت إن /dashboard نفسه مش متلفوف بـ ProtectedRoute
// خالص، فأي فحص جوه ProtectedRoute كان مش هيشتغل فور ما اليوزر يعمل لوجين.
// هنا بتتطبق على كل صفحة (بما فيها /dashboard) من غير ما تلمس ProtectedRoute
const SetupGate = ({ children }) => {
  const { user, loading, needsSetup, setupLoading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading || setupLoading || !user) return;

    if (needsSetup && location.pathname !== '/setup') {
      navigate('/setup', { replace: true });
    } else if (!needsSetup && location.pathname === '/setup') {
      navigate('/dashboard', { replace: true });
    }
  }, [user, loading, needsSetup, setupLoading, location.pathname, navigate]);

  return children;
};

export default SetupGate;
